import type { ChipTone } from '@orbitalwatch/design';

/** Change-request states (inventory "Enumerations"). */
export type ChangeRequestState = 'Proposed' | 'Approved' | 'Applied' | 'Rejected' | 'Failed' | 'Withdrawn';
/** Change kinds of a change request (inventory "Enumerations"). */
export type ChangeKind = 'new' | 'edited' | 'deleted' | 'moved' | 'files';

const STATE_TONE: Record<ChangeRequestState, ChipTone> = {
    Proposed: 'warning',
    Approved: 'success',
    Applied: 'success',
    Rejected: 'danger',
    Failed: 'danger',
    Withdrawn: 'neutral',
};

/** Chip tone of a change-request state; unknown states read neutral. */
export function stateTone(state: string): ChipTone {
    return STATE_TONE[state as ChangeRequestState] ?? 'neutral';
}

export const KIND_TONE: Record<ChangeKind, ChipTone> = {
    new: 'success',
    edited: 'info',
    deleted: 'danger',
    moved: 'warning',
    files: 'neutral',
};

export const KIND_LABEL: Record<ChangeKind, string> = {
    new: 'New',
    edited: 'Edited',
    deleted: 'Deleted',
    moved: 'Moved',
    files: 'Files',
};

/** Chip tone of a change kind. */
export function kindTone(kind: ChangeKind): ChipTone {
    return KIND_TONE[kind];
}
